module.exports = __webpack_public_path__ + "img/inviteBg.34624583.jpg";